import { TableColOrder, type TableColOrderValue } from "~/components/table/col-order";
import { ImmutableMap } from "~/tools/immutable-map";
import { Impulse, useScoped } from "~/tools/impulse";
import { prop } from "~/tools/prop";
import type { Record } from "~/tools/record";
import { toArray } from "~/tools/to-array";
import { usePermanent } from "~/tools/use-permanent";

import { Api, type OverviewSorting } from "../../common/openapi";

const TABLE_COL_ORDER_TO_SORTING_DIRECTION = {
	asc: Api.OverviewSortingDirection.Ascending,
	desc: Api.OverviewSortingDirection.Descending,
} satisfies Record<TableColOrderValue>;

interface UseOverviewSortingResult {
	sorting: Array<OverviewSorting>;
	orders: Impulse<ImmutableMap<string, TableColOrder>>;
}

export function useOverviewTableSorting(): UseOverviewSortingResult {
	const orders = usePermanent(() => Impulse(ImmutableMap.empty<string, TableColOrder>()));

	const sorting = useScoped(
		(scope) => {
			const entries = toArray(orders.getValue(scope).entries());

			return TableColOrder.sort(entries, prop(1)).map(([[columnId], order]) => ({
				columnId,
				direction: TABLE_COL_ORDER_TO_SORTING_DIRECTION[order],
			}));
		},

		[orders],
	);

	return { sorting, orders };
}
